import React from 'react';
import Box from '@mui/material/Box';


const ButtonBox = ({ children }) => {
    return(
    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        {children}
    </Box>
    )
  
}

export default ButtonBox;